// extracted by mini-css-extract-plugin
export default {"container":"Promotions-container-WCU","content":"Promotions-content-Y1K","link":"Promotions-link-1xH","image":"Promotions-image-8Gk","title":"Promotions-title-1JD"};